const issues = [
  "Sliding door is stuck or hard to open",
  "Window won't lock or latch",
  "Crank handle broken or stripped",
  "Door handle came off",
  "Sliding door grinding noise",
  "Window stuck open or closed",
  "Lock mechanism not engaging",
  "Roller fell off track",
];

export default function CommonIssues() {
  return (
    <section className="w-full bg-white py-16">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-secondary mb-3">
            Common Hardware Problems We Fix
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {issues.map((issue) => (
            <div
              key={issue}
              className="flex items-center gap-3 bg-[#f8fafc] rounded-lg px-4 py-3"
            >
              <i className="ri-checkbox-circle-fill text-primary text-lg shrink-0" />
              <span className="text-sm md:text-base text-secondary">{issue}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}